import { render, staticRenderFns } from "./kardex.vue?vue&type=template&id=595aa202&scoped=true"
import script from "./kardex.vue?vue&type=script&lang=js"
export * from "./kardex.vue?vue&type=script&lang=js"
import style0 from "./kardex.vue?vue&type=style&index=0&id=595aa202&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "595aa202",
  null
  
)

export default component.exports